"use client";

import { useState } from "react";
import { Group, Text, UnstyledButton, Box } from "@mantine/core";
import { IconBell, IconChevronRight } from "@tabler/icons-react";

interface PriceDropCtaProps {
  isFavorited: boolean;
  isMonitored: boolean;
  onOpenPriceMonitor: () => void;
}

export const PriceDropCta = ({ isMonitored, onOpenPriceMonitor }: PriceDropCtaProps) => {
  const [isHovered, setIsHovered] = useState(false);

  const TitleText = isMonitored ? "You're watching this item" : "Get notified if the price drops";

  const helperText = isMonitored
    ? "We'll notify you when the price changes"
    : "We'll save this item to your favorites automatically.";

  return (
    <UnstyledButton onClick={onOpenPriceMonitor} style={{ width: "100%" }}>
      <Group
        gap="sm"
        p="sm"
        style={{
          border: "1px solid var(--mantine-color-gray-4)",
          borderRadius: "var(--mantine-radius-default)",
          transition: "border-color 0.15s ease",
          borderColor: isMonitored ? "#1500ff" : isHovered ? "#1500ff" : undefined,
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => {
          setIsHovered(false);
        }}
      >
        <Box c={isMonitored ? "#1500ff" : "var(--mantine-color-dimmed)"}>
          <IconBell size={16} fill={isMonitored ? "currentColor" : "none"} />
        </Box>
        <Box style={{ flex: 1, textAlign: "left" }}>
          <Text fz="var(--mantine-font-size-xs)" lh={1.2} fw={600} tt="none">
            {TitleText}
          </Text>
          <Text fz="var(--mantine-font-size-xs)" lh={1.35} mt={2}>
            {helperText}
          </Text>
        </Box>
        <Box c={isMonitored || isHovered ? "#1500ff" : "var(--mantine-color-gray-4)"}>
          <IconChevronRight size={14} color="black" />
        </Box>
      </Group>
    </UnstyledButton>
  );
};
